export function PaidFeatureBadge() {
  return <span className="paid-feature-badge" title="Paid feature — Pro plan only">Paid</span>;
}
